export default __webpack_public_path__ + "static/media/pen-icon.ded0fe04.svg";